/**
 * Strip non-printable control characters that cause garbled text on print.
 */
const sanitize = (s: string): string =>
  // biome-ignore lint/suspicious/noControlCharactersInRegex: intentional strip of non-printable control characters
  s.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '');

/**
 * Escape a string for safe interpolation into HTML template literals.
 * Prevents XSS by using the browser's built-in text content encoding.
 */
export const escapeHtml = (s: string | null | undefined): string => {
  if (!s) return '';
  const el = document.createElement('span');
  el.textContent = sanitize(s);
  return el.innerHTML;
};
